import { Divider, Typography, useMediaQuery } from "@mui/material";
import { EditIconCard } from "../../../../../../../../assets/images";
import { MuiRightDrawer } from "../../../../../../../../builderPackage/components";
import { DynamicFormBuilderContainer } from "../../../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { useAppSelector } from "../../../../../../../../store/hooks";
import { faintGray, mobilenoblack, secondaryTextGray } from "../../../../../../../../theme/palette";
import { systemColor } from "../../../../../../../../theme/systemColor";
import { dateFormate } from "../../../../../../../../utils/utils";
import { DocFileIconSVG, DownloadIconSVG, ImageFileIconSVG, PDFFileIconSVG } from "../../../../../../purchaseRequistion/assets/customIcons";
import { interWarehouseRequisitionOtherDetailsAPICall } from "../../services/apiCall";
import { InterWarehouseTransferRequisitionKeys } from "../../services/entity";
import { AddedParts } from "./addedParts";
import { StatusProgressComponent } from "./stepperComponent";
import { CrossIcon } from "../../../../../../../../assets/images";
export var MoreDetails = function (props) {
    var _crud$getPartsApiKey, _getAmt, _rowData$DocumentCode, _dateFormate2;
    var rowData = props.rowData, handleRowEditClick = props.handleRowEditClick, handleDrawerClose = props.handleDrawerClose, getPartsApiKey = props.getPartsApiKey;
    var crud = useAppSelector(function (state) { return state.crud; });
    var totalItems = (_crud$getPartsApiKey = crud[getPartsApiKey]) === null || _crud$getPartsApiKey === void 0 || (_crud$getPartsApiKey = _crud$getPartsApiKey.data) === null || _crud$getPartsApiKey === void 0 ? void 0 : _crud$getPartsApiKey.length;
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    // const otherData = crud[InterWarehouseTransferRequisitionKeys.OtherDetails]?.data
    var getAmt = function () {
        var amt = 0;
        for (var _i = 0, _a = (_crud$InterWarehouseT = (_crud$InterWarehouseT2 = crud[InterWarehouseTransferRequisitionKeys.GetPartList]) === null || _crud$InterWarehouseT2 === void 0 ? void 0 : _crud$InterWarehouseT2.data) !== null && _crud$InterWarehouseT !== void 0 ? _crud$InterWarehouseT : []; _i < _a.length; _i++) {
            var i = _a[_i];
            var _crud$InterWarehouseT, _crud$InterWarehouseT2;
            amt = amt + (i === null || i === void 0 ? void 0 : i.PurchasePrice) * (i === null || i === void 0 ? void 0 : i.RequestedQuantity);
        }
        return amt;
    };
    var renderIcon = function (contentType) {
        var type = contentType === null || contentType === void 0 ? void 0 : contentType.split('.')[1];
        switch (type) {
            case 'png':
                return /*#__PURE__*/ React.createElement(ImageFileIconSVG, {
                    sx: {
                        width: 40,
                        height: 40,
                        fontSize: 40,
                        color: faintGray
                    }
                });
            case 'jpg':
                return /*#__PURE__*/ React.createElement(ImageFileIconSVG, {
                    sx: {
                        width: 40,
                        height: 40,
                        fontSize: 40,
                        color: faintGray
                    }
                });
            case 'jpeg':
                return /*#__PURE__*/ React.createElement(ImageFileIconSVG, {
                    sx: {
                        width: 40,
                        height: 40,
                        fontSize: 40,
                        color: faintGray
                    }
                });
            case 'pdf':
                return /*#__PURE__*/ React.createElement(PDFFileIconSVG, {
                    sx: {
                        width: 40,
                        height: 40,
                        fontSize: 40,
                        color: faintGray
                    }
                });
            case 'doc':
                return /*#__PURE__*/ React.createElement(DocFileIconSVG, {
                    sx: {
                        width: 40,
                        height: 40,
                        fontSize: 40,
                        color: faintGray
                    }
                });
            case 'docx':
                return /*#__PURE__*/ React.createElement(DocFileIconSVG, {
                    sx: {
                        width: 40,
                        height: 40,
                        fontSize: 40,
                        color: faintGray
                    }
                });
            default:
                return null;
        }
    };
    var defaultValueGetter = function (state, field) {
        var _state, _field$name;
        return (_state = state === null || state === void 0 ? void 0 : state[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : '']) !== null && _state !== void 0 ? _state : '-';
    };
    var step1 = [{
            type: FormItemTypes.ContainerItem,
            name: 'actionPanel',
            label: '',
            value: null,
            columnSize: 12,
            // marginTop: 1,
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'TotalItems',
                    label: 'Total items',
                    value: totalItems !== null && totalItems !== void 0 ? totalItems : '-',
                    columnSize: 6,
                    align: 'left',
                    fontSize: '18px',
                    fontWeight: 500
                    // padding: '0px 0px 0px 24px',
                    // labelTypographyProps: {
                    //     align: 'left',
                    //     padding: '0px 0px 0px 24px'
                    // },
                }, {
                    type: FormItemTypes.Typography,
                    name: 'TotalAmount',
                    label: 'Total Amount (₹)',
                    value: (_getAmt = getAmt()) !== null && _getAmt !== void 0 ? _getAmt : '-',
                    columnSize: 6,
                    align: 'right',
                    fontSize: '18px',
                    fontWeight: 500,
                    labelTypographyProps: {
                        align: 'right'
                    }
                }]
        }, {
            type: FormItemTypes.Custom,
            name: "AddedParts",
            label: '',
            value: null,
            element: function () { /*#__PURE__*/ return React.createElement(AddedParts, {
                id: rowData === null || rowData === void 0 ? void 0 : rowData.id
            }); },
            columnSize: 12
        }];
    var step2 = [{
            type: FormItemTypes.Custom,
            name: "StatusProgressDetails",
            label: '',
            value: null,
            containerProps: {
                padding: 2
            },
            element: function () { /*#__PURE__*/ return React.createElement(StatusProgressComponent, {
                rowData: rowData
            }); },
            columnSize: 12
        }];
    var step3 = [{
            type: FormItemTypes.ContainerItem,
            name: 'Basic Details',
            label: 'Basic details',
            value: null,
            columnSize: 12,
            // marginX: 0.2,
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: "BasicDetails",
                    label: 'Basic details',
                    value: null,
                    fontSize: '14px',
                    columnSize: 12,
                    labelTypographyProps: {
                        color: mobilenoblack,
                        variant: 'h6',
                        fontWeight: 600
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: "DocumentCode",
                    label: 'Transfer requisition ID',
                    value: null,
                    columnSize: 4,
                    variant: 'h6'
                }, {
                    type: FormItemTypes.Typography,
                    name: "SourceWarehouse",
                    label: 'Source Warehouse',
                    value: null,
                    valueGetter: function (formValues, field) {
                        var _formValues$Name, _formValues, _field$name2;
                        return (_formValues$Name = formValues === null || formValues === void 0 || (_formValues = formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : '']) === null || _formValues === void 0 ? void 0 : _formValues["Name"]) !== null && _formValues$Name !== void 0 ? _formValues$Name : '-';
                    },
                    columnSize: 4,
                    variant: 'h6'
                }, {
                    type: FormItemTypes.Typography,
                    name: "DestinationWarehouse",
                    label: 'Destination Warehouse',
                    value: '',
                    valueGetter: function (formValues, field) {
                        var _formValues$Name2, _formValues2, _field$name3;
                        return (_formValues$Name2 = formValues === null || formValues === void 0 || (_formValues2 = formValues[(_field$name3 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name3 !== void 0 ? _field$name3 : '']) === null || _formValues2 === void 0 ? void 0 : _formValues2["Name"]) !== null && _formValues$Name2 !== void 0 ? _formValues$Name2 : '-';
                    },
                    columnSize: 4,
                    variant: 'h6'
                }, {
                    type: FormItemTypes.Typography,
                    name: "Priority",
                    label: 'Priority',
                    value: '',
                    valueGetter: function (formValues, field) {
                        var _formValues$Name3, _formValues3, _field$name4;
                        return (_formValues$Name3 = formValues === null || formValues === void 0 || (_formValues3 = formValues[(_field$name4 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name4 !== void 0 ? _field$name4 : '']) === null || _formValues3 === void 0 ? void 0 : _formValues3["Name"]) !== null && _formValues$Name3 !== void 0 ? _formValues$Name3 : '-';
                    },
                    columnSize: 4,
                    variant: 'h6'
                }, {
                    type: FormItemTypes.Custom,
                    name: "",
                    label: '',
                    value: null,
                    columnSize: 12,
                    element: function () { /*#__PURE__*/ return React.createElement(Divider, {
                        style: {
                            width: '100%'
                        }
                    }); }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'Logistic Details',
            label: 'Logistic details',
            value: null,
            columnSize: 12,
            // marginX: 0.2,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: "LogisticDetails",
                    label: 'Logistic Details',
                    value: null,
                    fontSize: '14px',
                    columnSize: 12,
                    labelTypographyProps: {
                        color: mobilenoblack,
                        variant: 'h5'
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: "TransporterName",
                    label: 'Transporter Name',
                    value: null,
                    columnSize: 4,
                    variant: 'h6',
                    valueGetter: defaultValueGetter
                }, {
                    type: FormItemTypes.Typography,
                    name: "ShippingMethodName",
                    label: 'Shipping method',
                    value: null,
                    columnSize: 4,
                    variant: 'h6',
                    valueGetter: defaultValueGetter
                }, {
                    type: FormItemTypes.Typography,
                    name: "ShippingDocumentNo",
                    label: 'Shipping reference doc no',
                    value: null,
                    columnSize: 4,
                    variant: 'h6',
                    valueGetter: defaultValueGetter
                }, {
                    type: FormItemTypes.Typography,
                    name: "ShippingDocumentDate",
                    label: 'Shipping reference doc date',
                    value: null,
                    columnSize: 4,
                    variant: 'h6',
                    valueGetter: defaultValueGetter
                }, {
                    type: FormItemTypes.Typography,
                    name: "BoxQuantity",
                    label: 'No. of boxes',
                    value: null,
                    columnSize: 4,
                    variant: 'h6',
                    valueGetter: defaultValueGetter
                }, {
                    type: FormItemTypes.Typography,
                    name: "VehicleNo",
                    label: 'Vehicle no',
                    value: null,
                    columnSize: 4,
                    variant: 'h6',
                    valueGetter: defaultValueGetter
                }, {
                    type: FormItemTypes.Typography,
                    name: "VehicleNo",
                    label: 'Road permit no',
                    value: null,
                    columnSize: 4,
                    variant: 'h6',
                    valueGetter: defaultValueGetter
                }, {
                    type: FormItemTypes.Typography,
                    name: "ExpectedTransferDate",
                    label: 'Expected transfer date',
                    value: null,
                    columnSize: 4,
                    variant: 'h6',
                    valueGetter: function (state, field) {
                        var _dateFormate, _field$name5;
                        return (_dateFormate = dateFormate(state === null || state === void 0 ? void 0 : state[(_field$name5 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name5 !== void 0 ? _field$name5 : ''])) !== null && _dateFormate !== void 0 ? _dateFormate : '-';
                    }
                }, {
                    type: FormItemTypes.Custom,
                    name: "",
                    label: '',
                    value: null,
                    columnSize: 12,
                    element: function () { /*#__PURE__*/ return React.createElement(Divider, {
                        style: {
                            width: '100%'
                        }
                    }); }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            // marginX: 0.2,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: "Notes & Attachments",
                    label: 'Notes & attachments',
                    value: null,
                    fontSize: '14px',
                    columnSize: 12,
                    labelTypographyProps: {
                        color: '#1B1D21',
                        variant: 'h6',
                        fontWeight: 600
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: "Remarks",
                    label: 'Transporter reason/notes',
                    value: null,
                    columnSize: 4,
                    variant: 'h6'
                }, {
                    type: FormItemTypes.List,
                    name: "Attachments",
                    label: 'Attachments',
                    value: null,
                    columnSize: 12,
                    containerProps: {
                        sx: {
                            marginBottom: 8
                        }
                    },
                    variant: 'compact',
                    columns: [{
                            field: 'Icon',
                            maxWidth: 40,
                            renderCell: function (params) { return renderIcon(params.row.Name); }
                        }, {
                            field: 'Name',
                            flex: 1
                        }, {
                            field: 'Size',
                            width: 80,
                            valueFormatter: function (value) { return "".concat(Math.round(value / 1000), " KB"); }
                        }],
                    disableCheckboxSelection: true,
                    rowHeight: 72
                }]
        }];
    var tabs = [{
            id: '0',
            label: 'Item details',
            elements: step1
        }, {
            id: '1',
            label: 'Status Progress',
            elements: step2
        }, {
            id: '2',
            label: 'Other',
            elements: step3
        }];
    var moreDetailsFormData = [{
            type: FormItemTypes.ContainerItem,
            name: 'header',
            label: '',
            flexDirection: 'row',
            columnSize: 12,
            marginTop: IS_DESKTOP ? 8 : 0,
            justifyContent: 'space-between',
            padding: '20px 0px',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'header',
                    label: 'More Details',
                    columnSize: 11,
                    labelTypographyProps: {
                        variant: 'h1',
                        color: mobilenoblack,
                        paddingX: '24px'
                    }
                }, {
                    type: FormItemTypes.IconButton,
                    name: 'Close',
                    columnSize: 1,
                    size: 'large',
                    children: /*#__PURE__*/ React.createElement("img", {
                        id: "crossIconBtn",
                        color: secondaryTextGray,
                        src: CrossIcon,
                        onClick: handleDrawerClose
                    }),
                    sx: {
                        padding: ' 0px 24px 0px 0px'
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'actionPanel',
            label: '',
            value: null,
            columnSize: 12,
            spacing: 0,
            bgcolor: systemColor.backgroundColor,
            sx: {
                flexGrow: 1,
                overflowY: 'auto',
                padding: '24px'
            },
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'IWRNUMBER',
                    label: 'IWR NUMBER',
                    value: null,
                    columnSize: 6,
                    paddingLeft: 3,
                    children: /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: '14px',
                        fontWeight: 500
                    }, (_rowData$DocumentCode = rowData === null || rowData === void 0 ? void 0 : rowData.DocumentCode) !== null && _rowData$DocumentCode !== void 0 ? _rowData$DocumentCode : '-'),
                    labelTypographyProps: {
                        variant: 'caption',
                        color: systemColor.lightGrey,
                        paddingLeft: 3
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: 'CREATED DATE',
                    label: 'CREATED DATE',
                    value: null,
                    columnSize: 6,
                    paddingLeft: 2,
                    children: /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: '14px',
                        fontWeight: 500
                    }, (_dateFormate2 = dateFormate(rowData === null || rowData === void 0 ? void 0 : rowData.CreatedOn)) !== null && _dateFormate2 !== void 0 ? _dateFormate2 : '-'),
                    labelTypographyProps: {
                        variant: 'caption',
                        color: systemColor.lightGrey,
                        paddingLeft: 2,
                        display: "flex",
                        justifyContent: "flex-end"
                    },
                    display: "flex",
                    justifyContent: "flex-end"
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: 'Tabs',
            tabs: tabs,
            variant: 'fullWidth',
            displayExpr: 'label',
            columnSize: 12,
            tabPanelProps: {
                sx: {
                    px: 3
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            position: 'fixed',
            width: {
                xs: '100%',
                sm: '600px'
            },
            justifyContent: 'end',
            bottom: 0,
            right: 0,
            spacing: 0,
            p: '16px 24px 24px 24px!important',
            columnGap: 2,
            bgcolor: 'white',
            borderTop: "1px solid ".concat(faintGray),
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'editButton',
                    value: null,
                    children: 'Edit',
                    columnSize: 0,
                    onClick: function () { return handleRowEditClick(rowData === null || rowData === void 0 ? void 0 : rowData.id); },
                    startIcon: /*#__PURE__*/ React.createElement("img", {
                        id: "moreDetail-edit-img",
                        src: EditIconCard,
                        alt: "Error"
                    }),
                    sx: {
                        background: 'none',
                        border: '1px solid #DEE4EB',
                        color: "".concat(systemColor.darkGrey)
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'DownloadPDF',
                    value: null,
                    children: 'Download as PDF',
                    columnSize: 0,
                    startIcon: /*#__PURE__*/ React.createElement(DownloadIconSVG, {
                        sx: {
                            width: 20,
                            height: 20,
                            color: systemColor.primary
                        }
                    }),
                    sx: {
                        background: 'none',
                        border: "1px solid ".concat(systemColor.primary)
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiRightDrawer, {
        id: "filter-drawer",
        anchor: "right",
        openDrawer: props.openDrawer,
        onClose: props.handleDrawerClose,
        sx: {
            width: {
                xs: '100%',
                sm: '800px'
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        formData: moreDetailsFormData,
        getRequest: {
            id: rowData === null || rowData === void 0 ? void 0 : rowData.id
        },
        getFormAPI: interWarehouseRequisitionOtherDetailsAPICall,
        getKey: InterWarehouseTransferRequisitionKeys.OtherDetails,
        formProps: {
            height: '100%'
        },
        gridProps: {
            height: '100%',
            alignContent: 'flex-start'
        }
    })));
};
